import React, { useState, useEffect } from "react";
import axios from "axios";

const API_BASE = "/api";

function Replies() {
  const [replies, setReplies] = useState([]);

  useEffect(() => {
    loadReplies();
  }, []);

  const loadReplies = async () => {
    try {
      const res = await axios.get(`${API_BASE}/messages`);
      setReplies(res.data);
    } catch (error) {
      console.error("Error loading replies:", error);
    }
  };

  const handleDelete = async (file) => {
    if (!window.confirm("Delete this reply?")) return;

    try {
      await axios.delete(`${API_BASE}/replies`, { data: { file } });
      alert("Reply deleted!");
      loadReplies();
    } catch (error) {
      console.error("Error deleting:", error);
      alert("Error deleting: " + (error.response?.data?.message || error.message));
    }
  };

  const formatBytes = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  const formatDate = (timestamp) => {
    return new Date(timestamp * 1000).toLocaleString();
  };

  const formatDuration = (seconds) => {
    if (!seconds) return 'Unknown';
    if (seconds < 60) return `${seconds}s`;
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}m ${secs}s`;
  };

  return (
    <div className="management-page">
      <h1>Manage Replies</h1>

      <div className="file-list">
        {replies.length === 0 ? (
          <p>No replies received yet.</p>
        ) : (
          replies.map((reply) => (
            <div key={reply.file} className="file-item">
              <div className="file-info">
                <video src={reply.url} controls width="200" />
                <div className="file-details">
                  <strong>{reply.displayName}</strong>
                  <div className="file-meta">
                    {formatDuration(reply.duration)} • {formatBytes(reply.size)} • {formatDate(reply.modified)}
                  </div>
                </div>
              </div>
              <div className="file-actions">
                <a href={reply.url} download className="download-btn">⬇️ Download</a>
                <button onClick={() => handleDelete(reply.file)} className="danger">🗑 Delete</button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Replies;
